// sticky-main-navigation.js

import { who_get_css_device, who_throttle } from "./helpers";

export default class stickyMainNavigation{

	constructor(){

		this.body                  = document.querySelector('body') ;
		this.siteHeader            = document.querySelector('.site-header') ;
		this.siteHeader__bottomBar = document.querySelector('.site-header__bottom-bar') ;
		this.siteHeader__topBar    = document.querySelector('.site-header__top-bar') ;
		
		this.init();
	}

	init(){

		let img = document.querySelector('.site-header__logo-link img');
		this.waitingLoadImage( img.src ).then(images => {
			this.setBreakpointValue() ;
			this.setListeners() ;
		}) ;
	}

	setListeners(){

		window.addEventListener('scroll', () => { this.updateStickNavigation(); } );

		window.addEventListener('resize', () => {

			const resize_callback = () => {

				this.setBreakpointValue() ;
				this.updateStickNavigation()
			}

			who_throttle( resize_callback() ,350 );

		});

	}

	setBreakpointValue(){
		this.breakpoint = this.getBreakpointValue() ;
		// console.log(this.breakpoint);
	}

	getBreakpointValue(){

		const regex = /px/i;
		let value = 0 ;

		let siteheaderPaddingTop = window.getComputedStyle( this.siteHeader, null).getPropertyValue('padding-top') ;
		siteheaderPaddingTop = Number(siteheaderPaddingTop.replace(regex, '')) ;

		let siteHeader__topBarHeight = this.siteHeader__topBar.offsetHeight ;

		return siteheaderPaddingTop + siteHeader__topBarHeight  ;
	}


	/**
	 * Wait image URL loaded
	 *
	 * @param imageUrl
	 * @returns {Promise<*>}
	 */
	// https://stackoverflow.com/questions/37854355/wait-for-image-loading-to-complete-in-javascript
	async waitingLoadImage( imageUrl ) {
		let img;

		const imageLoadPromise = new Promise(resolve => {
			img = new Image();
			img.onload = resolve;
			img.src = imageUrl;
		});

		await imageLoadPromise;

		// console.log("image loaded");

		return img ;
	}

	getPlaceholderHeight(){

		// height + paddingTop, mais pas le bottom
		// because : 1er implémentation du design

		let siteHeaderPlaceholderHeight = this.siteHeader__bottomBar.clientHeight ;
		let computedStyle = window.getComputedStyle( this.siteHeader__bottomBar );

		return siteHeaderPlaceholderHeight - ( parseFloat(computedStyle.paddingBottom) );
	}


	updateStickNavigation(){

		// console.log('updateStickNavigation');

		let device = who_get_css_device() ;

		if( ( 'mobile' != device && 'tablet' != device ) ){

			let scroll__top  = window.pageYOffset || document.documentElement.scrollTop  ;

			if( scroll__top >= this.breakpoint ){

				let siteHeaderPlaceholderHeight = this.getPlaceholderHeight() ;
				document.body.style.setProperty("--who--js--sticky-header-placeholder--height", `${siteHeaderPlaceholderHeight}px`) ;

				if( ! this.body.classList.contains('has--sticky-navigation') ){
					this.body.classList.add('has--sticky-navigation');
				}

			}else{
				this.body.classList.remove('has--sticky-navigation');
			}


		}else{

			if( this.body.classList.contains('has--sticky-navigation') ){
				this.body.classList.remove('has--sticky-navigation');
			}
		}

	}

}